import React from 'react'

import { Button, Input, InputGroup, Modal, Panel, PanelGroup, Toggle } from 'rsuite'

import Icon from '@mdi/react'
import { mdiFilterOutline } from '@mdi/js'

import { Avatar, Divider, IconButton } from '@mui/material'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'

import css from './operators.module.scss'
import emptyDoc from './../../../../img/empty_documents.svg'
import Empty from '../../../_ui/empty'
import { BootstrapTooltip } from '../../../_ui/tooltip'
import avatar from './../../../../img/avatar.svg'
import AccessLevelUmkdContainer from './accessLevelUmkd/accessLevelUmkdContainer'
import AccessLevelPortfolioContainer from './accessLevelPortfolio/accessLevelPortfolioContainer'

const Operators = (props: any) => {
    return (
        <>
            {props.getAddOperatorVisible && <AddUser {...props} />}
            
            {props.getEditLoginVisible && <ChangeLogin {...props} />}
            {props.getEditPasswordVisible && <ChangePassword {...props} />}
            {props.getEditFIOVisible && <ChangeFIO {...props} />}
            {props.getEditPositionVisible && <ChangePosition {...props} />}
            {props.getEditPhoneVisible && <ChangePhone {...props} />}
            {props.getEditEmailVisible && <ChangeEmail {...props} />}

            {props.getAccessLevelUmkdVisible &&
                <AccessLevelUmkdContainer
                    selectedOperatorID={props.selectedOperatorID}
                    getAccessLevelUmkdVisible={props.getAccessLevelUmkdVisible}
                    onClickCloseEditAccessLevel={props.onClickCloseEditAccessLevel}
                />
            }

            {props.getAccessLevelPortfolioStudentVisible &&
                <AccessLevelPortfolioContainer
                    selectedOperatorID={props.selectedOperatorID}
                    getAccessLevelPortfolioStudentVisible={props.getAccessLevelPortfolioStudentVisible}
                    onClickCloseEditAccessLevel={props.onClickCloseEditAccessLevel}
                />
            }

            <div className={css.main}>
                <div className={css.header}>
                    <div className={css.headerTitle}>Операторы системы ({props.operatorsList.length})</div>

                    <div className={css.headerBar}>
                        <InputGroup inside style={{ width: "300px" }} disabled={props.operatorsList.length ? false : true}>
                            <InputGroup.Addon>
                                <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                            </InputGroup.Addon>

                            <Input type="text" size="md" placeholder="Фильтр операторов..."
                                autoComplete="off" style={{ paddingRight: "40px" }}
                                value={props.getFilterOperators}
                                onChange={value => props.setFilterOperators(value)}
                            />

                            {props.getFilterOperators &&
                                <InputGroup.Addon onClick={() => props.setFilterOperators('')} style={{ margin: "-7px -7px 0 0" }}>
                                    <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                        <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                            <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </BootstrapTooltip>
                                </InputGroup.Addon>
                            }
                        </InputGroup>

                        <Divider orientation="vertical" variant="middle" flexItem sx={{ m: "0 0" }} />

                        <BootstrapTooltip title="Добавить оператора" placement="bottom" arrow>
                            <IconButton size="medium" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => props.setAddOperatorVisible(true)}>
                                <GroupAddOutlinedIcon />
                            </IconButton>
                        </BootstrapTooltip>
                    </div>
                </div>

                <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

                <div className={css.body}>
                    <div className={css.thead}>
                        <div style={{ margin: "auto 0", textAlign: "center" }}></div>
                        <div style={{ margin: "auto 0" }}>Логин оператора</div>
                        <div style={{ margin: "auto 0" }}>ФИО оператора</div>
                        <div style={{ margin: "auto 0", textAlign: "center" }}>Дата создания</div>
                    </div>

                    <div className={css.tbody}>
                        {!props.operatorsList.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" />
                            : <PanelGroup accordion activeKey={props.selectedOperatorID} onSelect={props.onSelectedOperator}> {
                                props.operatorsList.filter((val: any) => {
                                    let stringReturn

                                    let loginName = val.loginName.toLowerCase().includes(props.getFilterOperators.toLowerCase())
                                    let userLastName = val.lastName.toLowerCase().includes(props.getFilterOperators.toLowerCase())
                                    let userFirstName = val.firstName.toLowerCase().includes(props.getFilterOperators.toLowerCase())
                                    let userSecondName = val.secondName.toLowerCase().includes(props.getFilterOperators.toLowerCase())

                                    if (loginName || userLastName || userFirstName || userSecondName) {
                                        stringReturn = val
                                    }

                                    return stringReturn
                                }).map((operator: any) => {
                                    return (
                                        <Panel key={operator.loginID} eventKey={operator.loginID} id={operator.loginID}
                                            header={
                                                <div className={css.trow}>
                                                    <div style={{ margin: "auto 0", textAlign: "center" }}>{operator.loginID}</div>
                                                    <div style={{ margin: "auto 0" }}>{operator.loginName}</div>
                                                    <div style={{ margin: "auto 0" }}>{`${operator.lastName} ${operator.firstName} ${operator.secondName}`}</div>
                                                    <div style={{ margin: "auto 0", textAlign: "center" }}>{operator.accountCreateDate}</div>
                                                </div>
                                            }>

                                            <OperatorProfile {...props} operator={operator} />
                                        </Panel>
                                    )
                                })
                            }</PanelGroup>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

// Данные профиля оператора
const OperatorProfile = (props: any) => {
    return (
        <div className={css.profileMain}>
            <div className={css.profileData}>
                <div className={css.dataAvatar}>
                    <BootstrapTooltip title="Аватарка оператора" placement="top" arrow>
                        <div>
                            <Avatar alt="Remy Sharp" src={props.operator.avatar || avatar} sx={{ width: 180, height: 180 }} />
                        </div>
                    </BootstrapTooltip>

                    <div className={css.dataAvatarOther}>
                        <div className={css.dataItem}>
                            <div>Аккаунт создан</div>
                            <div>{props.operator.accountCreateDate}</div>
                        </div>

                        <div className={css.dataItem}>
                            <div>Послдений вход</div>
                            <div>{props.operator.lastInput ? props.operator.lastInput : "Не заходил"}</div>
                        </div>

                        <div className={css.dataItemOther}>
                            <div style={{ margin: "auto 0" }}>Пароль: ****</div>

                            <BootstrapTooltip title="Изменить" placement="bottom" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => props.setEditPasswordVisible(true)}>
                                    <EditOutlinedIcon />
                                </IconButton>
                            </BootstrapTooltip>
                        </div>
                    </div>
                </div>

                <div className={css.dataMain}>
                    <div className={css.dataMaimItem}>
                        <div style={{ margin: "auto 0" }}>{`${props.operator.loginName}`}</div>

                        <BootstrapTooltip title="Редактировать" placement="left" arrow>
                            <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => {props.setEditLogin(props.operator.loginName); props.setEditLoginVisible(true)}}>
                                <EditOutlinedIcon />
                            </IconButton>
                        </BootstrapTooltip>
                    </div>

                    <div className={css.dataMaimItem}>
                        <div style={{ margin: "auto 0" }}>{`${props.operator.lastName} ${props.operator.firstName} ${props.operator.secondName}`}</div>

                        <BootstrapTooltip title="Редактировать" placement="left" arrow>
                            <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => {props.setEditLastName(props.operator.lastName); props.setEditFirstName(props.operator.firstName); props.setEditSecondName(props.operator.secondName); props.setEditFIOVisible(true)}}>
                                <EditOutlinedIcon />
                            </IconButton>
                        </BootstrapTooltip>
                    </div>

                    <div className={css.dataMaimItem}>
                        <div style={{ margin: "auto 0" }}>{`${props.operator.position ? props.operator.position : "Должность не указана"}`}</div>

                        <BootstrapTooltip title="Редактировать" placement="left" arrow>
                            <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => {props.setEditPosition(props.operator.position ? props.operator.position : ""); props.setEditPositionVisible(true)}}>
                                <EditOutlinedIcon />
                            </IconButton>
                        </BootstrapTooltip>
                    </div>

                    <div className={css.dataMaimItem}>
                        <div style={{ margin: "auto 0" }}>{`${props.operator.phoneNumber ? props.operator.phoneNumber : "Номер телефона не указан"}`}</div>

                        <BootstrapTooltip title="Редактировать" placement="left" arrow>
                            <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => {props.setEditPhone(props.operator.phoneNumber ? props.operator.phoneNumber.substring(2, props.operator.phoneNumber.length) : ""); props.setEditPhoneVisible(true)}}>
                                <EditOutlinedIcon />
                            </IconButton>
                        </BootstrapTooltip>
                    </div>

                    <div className={css.dataMaimItem}>
                        <div style={{ margin: "auto 0" }}>{`${props.operator.email ? props.operator.email : "Электронная почта не указана"}`}</div>

                        <BootstrapTooltip title="Редактировать" placement="left" arrow>
                            <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => {props.setEditEmail(props.operator.email ? props.operator.email : ""); props.setEditEmailVisible(true)}}>
                                <EditOutlinedIcon />
                            </IconButton>
                        </BootstrapTooltip>
                    </div>
                </div>
            </div>

            <div className={css.profileLevels}>
                <div className={css.levelsHead}>Уровни доступа оператора</div>

                <div className={css.levelsBody}>
                    {!props.operator.accessLevelList.length
                        ? <Empty image={emptyDoc} description="Данные отсутствуют" />
                        : props.operator.accessLevelList.map((data: any) => {
                            return (
                                <div key={data.accessLevelID} className={css.levelsRow}>
                                    <div style={{ margin: "auto 0" }}>{data.accessLevelName}</div>
                                    <Toggle size="lg" checked={data.isChecked}
                                        style={{ margin: "auto 0" }}
                                        checkedChildren="Открыто" unCheckedChildren="Закрыто"
                                        onChange={(check) => props.onChangeAccessLevelOperator(data.accessLevelID, check)}
                                    />

                                    <div style={{ textAlign: "right", margin: "auto 0" }}>
                                        <BootstrapTooltip title="Редактировать" placement="right" arrow hidden={!data.isChecked || data.accessLevelID === 4 || data.accessLevelID === 5}>
                                            <IconButton size="medium" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => props.onClickOpenEditAccessLevel(data.accessLevelID)}>
                                                <TuneOutlinedIcon />
                                            </IconButton>
                                        </BootstrapTooltip>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

// Добавление оператора
const AddUser = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.getAddOperatorVisible}>
            <div className="modal">
                <div className="modalHead">
                    Добавление нового оператора
                </div>

                <div className="modalBody" style={{ gap: "1rem" }}>
                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Логин оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getAddLogin}
                            onChange={value => props.setAddLogin(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setAddLogin('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Пароль оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getAddPassword} readOnly={true}
                            onChange={value => props.setAddPassword(value)}
                        />

                        <InputGroup.Addon onClick={() => props.generatePassword("addOperator")} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Сгенерировать новый пароль" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <SyncOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />
                    
                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Фамилия оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getAddLastName}
                            onChange={value => props.setAddLastName(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setAddLastName('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Имя оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getAddFirstName}
                            onChange={value => props.setAddFirstName(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setAddFirstName('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Отчество оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getAddSecondName}
                            onChange={value => props.setAddSecondName(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setAddSecondName('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />
                </div>
                
                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={props.onClickButtonCancelOperator}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={props.onClickButtonAddOperator}>ДОБАВИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}


// Окно редактирования логина оператора
const ChangeLogin = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.getEditLoginVisible}>
            <div className="modal">
                <div className="modalHead">
                    Изменение логина оператора
                </div>

                <div className="modalBody" style={{ gap: "1rem" }}>
                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Логин оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getEditLogin}
                            onChange={value => props.setEditLogin(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setEditLogin('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />
                </div>
                
                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={() => {props.setEditLoginVisible(false); props.setEditLogin('')}}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={() => {props.onClickButtonSaveDataUser('login')}}>ПРИМЕНИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}

// Окно редактирования пароля оператора
const ChangePassword = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.getEditPasswordVisible}>
            <div className="modal">
                <div className="modalHead">
                    Изменение пароля оператора
                </div>

                <div className="modalBody" style={{ gap: "1rem" }}>
                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Новый пароль оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getEditPassword}
                            onChange={value => props.setEditPassword(value)}
                        />

                        <InputGroup.Addon onClick={() => props.generatePassword("")} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Сгенерировать новый пароль" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <SyncOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />
                </div>
                
                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={() => {props.setEditPasswordVisible(false); props.setEditPassword('')}}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={() => {props.onClickButtonSaveDataUser('password')}}>ПРИМЕНИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}

// Окно редактирования ФИО оператора
const ChangeFIO = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.getEditFIOVisible}>
            <div className="modal">
                <div className="modalHead">
                    Изменение ФИО оператора
                </div>

                <div className="modalBody" style={{ gap: "1rem" }}>
                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Фамилия оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getEditLastName}
                            onChange={value => props.setEditLastName(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setEditLastName('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Имя оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getEditFirstName}
                            onChange={value => props.setEditFirstName(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setEditFirstName('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Отчество оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getEditSecondName}
                            onChange={value => props.setEditSecondName(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setEditSecondName('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />
                </div>
                
                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={() => {props.setEditFIOVisible(false); props.setEditLastName(''); props.setEditFirstName(''); props.setEditSecondName('')}}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={() => {props.onClickButtonSaveDataUser('fio')}}>ПРИМЕНИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}

// Окно редактирования должности оператора
const ChangePosition = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.getEditPositionVisible}>
            <div className="modal">
                <div className="modalHead">
                    Изменение должности оператора
                </div>

                <div className="modalBody" style={{ gap: "1rem" }}>
                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Должность оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getEditPosition}
                            onChange={value => props.setEditPosition(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setEditPosition('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />
                </div>
                
                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={() => {props.setEditPositionVisible(false); props.setEditPosition('')}}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={() => {props.onClickButtonSaveDataUser('position')}}>ПРИМЕНИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}

// Окно редактирования телефона оператора
const ChangePhone = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.getEditPhoneVisible}>
            <div className="modal">
                <div className="modalHead">
                    Изменение телефона оператора
                </div>

                <div className="modalBody" style={{ gap: "1rem" }}>
                    <InputGroup inside>
                        <InputGroup.Addon>+7</InputGroup.Addon>

                        <Input type="text" size="md" placeholder="Номер телефона оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getEditPhone}
                            onChange={value => props.setEditPhone(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setEditPhone('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />
                </div>
                
                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={() => {props.setEditPhoneVisible(false); props.setEditPhone('')}}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={() => {props.onClickButtonSaveDataUser('phone')}}>ПРИМЕНИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}

// Окно редактирования электронной почты оператора
const ChangeEmail = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.getEditEmailVisible}>
            <div className="modal">
                <div className="modalHead">
                    Изменение электронной почты
                </div>

                <div className="modalBody" style={{ gap: "1rem" }}>
                    <InputGroup inside>
                        <Input type="text" size="md" placeholder="Электронная почта оператора"
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getEditEmail}
                            onChange={value => props.setEditEmail(value)}
                        />

                        <InputGroup.Addon onClick={() => props.setEditEmail('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="right" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    </InputGroup>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />
                </div>
                
                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={() => {props.setEditEmailVisible(false); props.setEditEmail('')}}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={() => {props.onClickButtonSaveDataUser('email')}}>ПРИМЕНИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}

export default Operators